<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.7071 15.2929L17.7071 20.2929C18.0976 20.6834 18.0976 21.3166 17.7071 21.7071C17.3166 22.0976 16.6834 22.0976 16.2929 21.7071L12 17.4142L7.70711 21.7071C7.31658 22.0976 6.68342 22.0976 6.29289 21.7071C5.90237 21.3166 5.90237 20.6834 6.29289 20.2929L11.2929 15.2929C11.6834 14.9024 12.3166 14.9024 12.7071 15.2929ZM6.29289 2.29289C6.65338 1.93241 7.22061 1.90468 7.6129 2.2097L7.70711 2.29289L12 6.58579L16.2929 2.29289C16.6834 1.90237 17.3166 1.90237 17.7071 2.29289C18.0676 2.65338 18.0953 3.22061 17.7903 3.6129L17.7071 3.70711L12.7071 8.70711C12.3466 9.06759 11.7794 9.09532 11.3871 8.7903L11.2929 8.70711L6.29289 3.70711C5.90237 3.31658 5.90237 2.68342 6.29289 2.29289Z"
    fill="currentColor"
  />
</svg>
